export const urlRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/gm;
export const numbersRegex = /^-?\d+\.?\d*$/gm;
export const MAX_CHARS_LENGTH_FOR_REVIEW_AJAX_CALL = 2;


// WEBPACK FOOTER //
// ./src/components/helpers/constants.js